<template lang="">
    <main-wrapper @back="goBack">
        <template slot="nav">
            <div class="nav-wrapper">
                <p> {{ this.survey_title || '调查问卷'}}</p>
            </div>
        </template>
        
        <template slot="main">
            <div class="main-wrapper">
                <div class="survey-wrapper">
                <yioks-loading v-show="isLoading"></yioks-loading>
                <div class="content-wrapper">
                    <vue-scroll :ops="ops" ref="vs">
                    <div class="scroll-content">
                        <div class="page-tips" v-if="introduction">
                        <p style="text-indent: 2em">
                            <span>导言：</span>
                            {{this.introduction}}
                        </p>
                        </div>
                        <el-form ref="formOfSurvey" :model="formData" :show-message="false">
                        <!-- :show-message="false" -->
                        <div class="table">
                            <div class="thead">
                            <div class="tr">
                                <div class="th question">
                                <strong>问题</strong>
                                </div>
                                <div class="th question-type">
                                <strong>问题类型</strong>
                                </div>
                                <div class="th question-answer">
                                <strong>答案</strong>
                                </div>
                            </div>
                            </div>
                            <div class="tbody" v-if="isEmpty">
                            <template v-for="(item, index) in formData.questionList">
                                <div class="tr" :key="index">
                                <div class="td question">
                                    <p>{{ item.item_title }}</p>
                                </div>
                                <div class="td question-type">
                                    <p>{{ item.item_type | typeFilter }}</p>
                                </div>
                                <div class="td question-answer">
                                    <!-- 单选 -->
                                    <div
                                    class="check-box"
                                    v-if="item.item_type === 0"
                                    key="alone"
                                    >
                                    <el-form-item
                                        label=""
                                        :prop="'questionList.' + index + '.answerList'"
                                        :rules="{
                                        required: true,
                                        message: '必填项',
                                        trigger: 'change',
                                        }"
                                        :inline-message="true"
                                    >
                                        <el-radio-group
                                        v-model="item.answerList"
                                        @change="singleChange(item)"
                                        >
                                        <el-radio
                                            v-for="(option, index) in item.options"
                                            :key="option.options_id + index"
                                            :label="option.options_id"
                                            :name="'' + option.item_id"
                                            border
                                        >
                                            {{ option.item_val }}
                                        </el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    </div>

                                    <!-- 多选 -->
                                    <div
                                    class="check-box"
                                    v-else-if="item.item_type === 1"
                                    key="multiply"
                                    >
                                    <el-form-item
                                        label=""
                                        :prop="'questionList.' + index + '.answerList'"
                                        :rules="{
                                        required: true,
                                        message: '必填项',
                                        trigger: 'change',
                                        }"
                                        :inline-message="true"
                                    >
                                        <el-checkbox-group
                                        v-model="item.answerList"
                                        @change="multiplyChange(item)"
                                        >
                                        <el-checkbox
                                            v-for="option in item.options"
                                            :key="option.options_id + index"
                                            :label="option.options_id"
                                            :name="'' + option.item_id"
                                            border
                                            >{{ option.item_val }}</el-checkbox
                                        >
                                        </el-checkbox-group>
                                    </el-form-item>
                                    </div>

                                    <!-- 问答 -->
                                    <div class="input-box" v-else key="inputs">
                                    <el-form-item
                                        label=""
                                        :prop="'questionList.' + index + '.answer'"
                                        :rules="{
                                        required: true,
                                        message: '必填项',
                                        trigger: 'change',
                                        }"
                                        :inline-message="true"
                                    >
                                        <el-input
                                        type="textarea"
                                        :rows="3"
                                        class="w100"
                                        v-model="item.answer"
                                        placeholder=""
                                        @blur="inputBlur(item)"
                                        ></el-input>
                                    </el-form-item>
                                    </div>
                                </div>
                                </div>
                            </template>
                            </div>
                            <yioks-empty v-else></yioks-empty>
                        </div>
                        </el-form>
                        <div class="page-tips mt-10" v-if="epilogue">
                        <p style="text-indent: 2em">
                            <span>结语：</span>
                            {{ epilogue }}
                        </p>
                        </div>
                    </div>
                    </vue-scroll>
                </div>
                </div>
                <div class="btn-box">
                  <el-button type="primary" @click="formConfirm('formOfSurvey')"
                      >提交</el-button
                  >
                  <el-button type="danger" @click="formCancel('formOfSurvey')"
                      >取消</el-button
                  >
                </div>
                 <yioks-tips :showTips="isShowSubmite"
                            tips="提交之后不能更改，确定提交吗？"
                            @hideTips="handleConfirmSubmit"></yioks-tips>
                <yioks-tips :showTips="backTips"
                  tips="确认是否放弃提交并返回吗?"
                  @hideTips="hideBackTips"></yioks-tips>
            </div>
        </template>
    </main-wrapper>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import { getQuestion, postQuestion } from "@/api/survey";
import {storageData} from "@/assets/js/storage";

const SURVEY_ID = 1;

export default {
  name: "SurveyIndex",

  data() {
    return {
      isShowSubmite: false,
      isLoading: false,
      isEmpty: true,
      ops: ops(),
      backTips: false,
      questionList: [],
    //   survey_id: SURVEY_ID,
      formData: {
        questionList: [],
      },
      epilogue: '',  // 导言
      introduction: '',   // 结语
      survey_title: '',   // 题目
    };
  },

  computed: {
      survey_id() {
          return this.$route.query.survey_id || 1;
      },
  },

  components: {
    "main-wrapper": () => import("@/components/LayOut/Common/up-down"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-tips": () => import('@/components/Tips/Dialog'),
  },

  created() {
    this.getQuestion();
  },

  filters: {
    typeFilter(val) {
      let tips = "";
      switch (+val) {
        case 0:
          tips = "单选";
          break;
        case 1:
          tips = "多选";
          break;
        case 2:
          tips = "问答";
          break;
        default:
          tips = "--";
          break;
      }
      return tips;
    },
  },

  methods: {
    /* 后退方法 */
    goBack() {
      this.$router.go(-1);
    },

    /* 获取问题列表 */
    getQuestion() {
      this.isLoading = true;
      const params = {
        survey_id: this.survey_id,
      };
      getQuestion(params)
        .then((res) => {
          this.isLoading = false;
          const { msg, status, result } = res.data;
          if (status === 0) {
            const { questionItem, questionOptions, questionInfo } = result;
            if (questionItem.length) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            const { epilogue, introduction, survey_title } = questionInfo;
            this.epilogue = epilogue;
            this.introduction = introduction;
            this.survey_title = survey_title;
            this.questionList = questionItem.map((item) => {
              const {
                item_title,
                item_type,
                survey_id,
                item_id,
                ...rest
              } = item;
              let options = null;
              if (2 === +item_type) {
                options = "";
              } else {
                options = this.handleQuestionOptions(
                  survey_id,
                  item_id,
                  questionOptions
                );
              }
              const aimObj = {
                item_id, // 问题id
                item_title, // 问题内容
                item_type, // 问题类型0：单选；1：多选；2：文本答案
                survey_id, // 问卷id
                options, // 对应答案可选项
                answer: "", // 对应问答答案
                answerList: [], // 对应选择答案
                aimAnswer: "", // 要提交的问题答案
              };
              return aimObj;
            });

            this.$set(this.formData, "questionList", this.questionList);
          } else {
            this.isEmpty = false;
            this.isLoading = false;
            this.$message.error(msg);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    },

    /* 处理问题选项 */
    handleQuestionOptions(surveyId, questionId, questionList) {
      let returnList = [];
      questionList.forEach((item) => {
        if (surveyId === item.survey_id && questionId === item.item_id) {
          returnList.push(item);
        }
      });
      return returnList;
    },

    /* 处理单选问题 */
    singleChange(formItem) {
      formItem.aimAnswer = formItem.answerList;
      // console.log("this.formData", this.formData)
    },

    /* 处理多选问题 */
    multiplyChange(formItem) {
      formItem.aimAnswer = formItem.answerList.join(",");
      // console.log("this.formData", this.formData)
    },

    /* 处理问答问题 */
    inputBlur(formItem) {
      formItem.aimAnswer = formItem.answer;
      // console.log("this.formData", this.formData)
    },

    /* 保存问卷答案 */
    formConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
         this.isShowSubmite = true;
        } else {
          this.$message.error("请完成所有问卷内容后提交");
        }
      });
    },

    /* 确认提交问卷 */
    handleConfirmSubmit(bool, flag) {
      if (flag) {
        this.submitFunction();
      }
      this.isShowSubmite = bool;
    },

    /* 提交问卷方法 */
    submitFunction() {
       const questionList = this.handleSubmitData(this.formData.questionList);
          const aimData = {
            survey_id: this.survey_id,
            question_answer: JSON.stringify(questionList)
          }

          postQuestion(aimData).then(res => {
            const { msg, status, result } = res.data;
            if (status === 0 ) {
              this.$message.success("问卷调查提交成功")
              this.$router.go(-1);
            } else {
              this.$message.error(msg)
            }
          }).catch(err => {
            console.log(err)
          })
    },

    /* 取消 */
    formCancel(formName) {
      this.backTips = true;
    },
    hideBackTips(bool, flag) {
      if (flag) {
        this.$router.go(-1);
      }
      this.backTips = bool;
    },

    /* 重新组装提交数据 */
    handleSubmitData(sourceData) {
      const aimList = sourceData.map((item) => {
        const { survey_id, aimAnswer, item_id, item_type, ...rest } = item;
        return { aimAnswer: aimAnswer + "", item_id, item_type };
      });
      return aimList;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
@import '~@/assets/css/mixin';
@import '~@/assets/css/nav_filter';

.nav-wrapper {
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 0;
  font-size: $font_size_big;
}

.main-wrapper {
  width: 100%;
  padding: 0 0 25px 0;
  font-size:$font_size_medium;
}

.survey-wrapper {
  background-color: $block_bg_color_base;

  .page-tips {
    padding: 10px 0px 20px;
    font-size: $font_size_medium;
  }

  .content-wrapper {
    height: 585px;
    padding: 25px 0;
    .scroll-content {
      padding: 0 20px 0;

      .table {
        border: 1px solid $color_white;

        .thead {
          .tr {
            display: flex;
            height: 45px;
            border-bottom: 1px solid $color_white;
          }
        }

        .tbody {
          .tr {
            display: flex;
            // height: 45px;
            border-bottom: 1px solid $color_white;

            &:last-child {
              border-bottom: none;
            }
          }
        }

        .td, .th {
          height: inherit;
          border-right: 1px solid $color_white;
          display: flex;
          justify-content: center;
          align-items: center;

          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}

.question {
  width: 35%;
}

.question-type {
  width: 10%;
}

.question-answer {
  width: 55%;
}

.check-box {
  width: 100%;
  display: flex;
  padding: 10px 5px 5px;
  justify-content: center;
  align-items: center;
}

.input-box {
  width: 100%;
  padding: 3px;

  .w100 {
    width: 100%;
  }
}

.btn-box {
  margin: 8px auto auto;
  width: 25%;
  display: flex;
  justify-content: center;
}

.mt-10 {
  margin-top: 10px;
}

.pt-10 {
  padding-top: 10px;
}
</style>

<style lang="stylus">
@import '~@/assets/css/variable';

.survey-wrapper {
  .check-box {
    .el-checkbox:first-child {
      margin-left: 10px;
    }

    .el-radio:first-child {
      margin-left: 10px;
    }

    .el-checkbox, .el-radio {
      margin-bottom: 5px;
    }
  }

  .el-checkbox__label {
    color: $color_white;
  }

  .el-radio__label {
    color: $color_white;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item__error {
    position: absolute;
    bottom: -15px;
    left: 0;
  }
}
</style>
